import MenuCatalog from "../components/MenuCatalog";

export default function CateringMenuPage() {
  return (
    <MenuCatalog
      seoTitle="Catering Menu"
      seoDescription="Browse The Canopy catering menu with meats by the pound, wings, sides, soups, platters, and party-ready favorites."
      seoPath="/menu/catering"
      seoImage="/images/meatplatters.avif"
      pageTitle="Catering Menu"
      pageSubtitle="Party-ready pit beef, barbecue, wings, sides, and platters for groups of all sizes."
      dataUrl="/catering-menu.json"
      actions={[
        {
          label: "Main Menu",
          to: "/menu",
          variant: "primary",
        },
        {
          label: "Catering Info",
          to: "/catering",
          variant: "secondary",
        },
      ]}
    />
  );
}
